import type { Weekdays } from '~/types/graphql/graphql';
import type { AggregationLevel } from '~/types/new/energy';

export const coreDate = () => {
  const { t } = useI18n();

  const week: Record<Weekdays['value'], number> = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const aggregationLevelOptions: { label: string; key: AggregationLevel }[] = [
    {
      label: t('global.minute'),
      key: 'minute',
    },
    {
      label: t('global.hour'),
      key: 'hour',
    },
    {
      label: t('global.day'),
      key: 'day',
    },
    {
      label: t('global.week'),
      key: 'week',
    },
    {
      label: t('global.month'),
      key: 'month',
    },
  ];

  const aggregationLevelOptionsWithout = (keys: AggregationLevel[]): { label: string; key: AggregationLevel }[] => {
    return aggregationLevelOptions.filter((option) => !keys.includes(option.key));
  };

  return {
    week,
    aggregationLevelOptions,
    aggregationLevelOptionsWithout,
  };
};
